module.exports = __webpack_public_path__ + "img/bicycle.0a059083.jpg";